// context/index.tsx
import React, { ReactElement, useMemo } from 'react';

const contextModules = require.context('.', false, /\.tsx$/);

const providers: React.FC[] = [];

contextModules.keys().forEach((key) => {
    if (key === './index.tsx') return; // Skip the index file itself

    const module = contextModules(key);
    const providerName = Object.keys(module).find((exportName) =>
        exportName.endsWith('Provider')
    );

    if (providerName) {
        providers.push(module[providerName]);
    }
});

const AppProvider: React.FC<{ children: ReactElement; }> = ({ children }) => {
  const tree = useMemo(() => {
    return providers.reduceRight<ReactElement>(
      (acc, Provider) => React.createElement(Provider, {}, acc),
      children
      );
  }, [children]); // you can include `providers` in deps if it ever changes

  return tree;
};

export default AppProvider;